  export default function contentFile(value, params) {	
    console.log(value, params);
    return value;
}